"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { Benefit } from "./benefits-eon";
export interface FlipCardProps extends Benefit {
  // Render as <li> only inside a real <ul> (the desktop grid); the mobile
  // carousel wraps each card in a div, where an <li> would be an orphan.
  as?: "li" | "div";
  className?: string;
}
export function FlipCard(t0) {
  const $ = _c(26);
  const {
    title,
    text,
    icon,
    className,
    as: t1
  } = t0;
  const Comp = t1 === undefined ? "div" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("group h-full cursor-pointer list-none [perspective:1000px]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("relative h-full min-h-[14rem] w-full", "transition-transform duration-700 ease-out [transform-style:preserve-3d]", "[transform:translateZ(0)_rotateX(0deg)] group-hover:[transform:translateZ(0)_rotateX(180deg)]");
    t4 = cn("absolute inset-0 flex flex-col items-start justify-between gap-4", "bg-primary p-8 [backface-visibility:hidden]");
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== icon) {
    t5 = <div className="mb-4 rounded-xl bg-white text-brand">{icon}</div>;
    $[4] = icon;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <h3 className="font-bold text-2xl text-white leading-tight lg:text-3xl" data-source="lc">{title}</h3>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== text) {
    t7 = <div className="text-white md:hidden" data-source="lc"><p>{text}</p></div>;
    $[8] = text;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("absolute inset-0 flex flex-col items-center justify-center text-center", "bg-primary p-6 [backface-visibility:hidden]", "[transform:rotateX(180deg)]");
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== text) {
    t11 = <div className={t10}><p className="text-base text-white leading-relaxed lg:text-lg" data-source="lc">{text}</p></div>;
    $[17] = text;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <div className={t3}>{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== Comp || $[23] !== t12 || $[24] !== t2) {
    t13 = <Comp className={t2}>{t12}</Comp>;
    $[22] = Comp;
    $[23] = t12;
    $[24] = t2;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}